import { RewardsProgram } from "~/entities/rewards/types";

type Props = {
  program: RewardsProgram;
};

// Rails version: app/views/rewards/messages/_registration.html.slim
const RewardsEnteredMessage: React.FC<Props> = ({ program }) => (
  <div className="flex flex-col items-center gap-3 mt-[10px]">
    <p className="text-sm">
      You&apos;re entered in our {program.name}! Stay signed in — every dollar
      you spend earns more entries.
    </p>
    <a
      href={program.landingPath}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center h-8 text-lg rounded-md px-[15px] uppercase text-white bg-gradient-to-b from-black100 to-gray hover:from-gray hover:to-gray"
    >
      View the {program.name}
    </a>
  </div>
);

export default RewardsEnteredMessage;
